"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicsService = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-topics-v1-topic/http");
var base_social_content_service_1 = require("./base-social-content.service");
var TopicsService = /** @class */ (function (_super) {
    tslib_1.__extends(TopicsService, _super);
    function TopicsService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicsService.prototype.create = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.createTopic(tslib_1.__assign({ contextId: this.groupId }, body)))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TopicsService.prototype.delete = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.deleteTopic(body))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TopicsService.prototype.list = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.listTopics(tslib_1.__assign({ contextId: this.groupId }, body)))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TopicsService.prototype.update = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.updateTopic(body))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return TopicsService;
}(base_social_content_service_1.BaseSocialContentService));
exports.TopicsService = TopicsService;
//# sourceMappingURL=topics.service.js.map